import { IOffer } from '@rbi-ctg/menu';

export const shouldShowMoreLeftFlag = (offer: IOffer) => (offer?.numberAvailable || 0) > 1;
